// Library Imports
import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import * as BsIcons from 'react-icons/bs'

// Asset Imports
import '../../assets/css/stylesheets/components/banner/PageBanner.css'

function PageBanner({pageName}) { 
  return (
    <Container className='pagebanner' fluid>
        <Row className='align-self-center'>
            <Col>
                <h1 className='pagebanner-header slide-in-fwd-center'>{pageName}</h1>
                <div className='pagebanner-heirarchy slide-in-fwd-center'>
                    Jersey Directory
                    <BsIcons.BsSlash className='pagebanner-heirarchy-icon' />
                    <span>{pageName}</span>
                </div>
            </Col>
        </Row>
    </Container>
  )
}

export default PageBanner